import { defaultWorkspaceApiClient } from '@affine/core/modules/cloud';

export interface PrivateFolderStorageUsage {
  userId: string;
  name: string | null;
  email: string;
  avatarUrl: string | null;
  /** Null until the member has opened the private area for the first time. */
  privateFolderId: string | null;
  usedBytes: number;
  limitBytes: number;
  limitSource: 'workspace' | 'group' | 'user';
  limitSourceGroupId: string | null;
  limitSourceGroupName: string | null;
  usagePercent: number;
  docCount: number;
  blobCount: number;
}

/** What the signed-in member uses of the private area of a workspace. */
export async function fetchMyPrivateFolderStorage(
  workspaceId: string,
  signal?: AbortSignal
): Promise<PrivateFolderStorageUsage | null> {
  return defaultWorkspaceApiClient.requestJson<PrivateFolderStorageUsage | null>(
    {
      workspaceId,
      path: `/api/workspace/${workspaceId}/storage/private/me`,
      init: { signal },
      category: 'settings',
      key: 'private-storage:me',
      mode: 'background',
      priority: 'visible',
    }
  );
}
